export const createOperationIcon = operationSign => {
    if (!operationSign) {operationSign = '=';}
    let icon;
    switch (operationSign) {
        case '=':
            icon = <i className="iconfont icon-dengyu" />;
            break;
        case '>':
            icon = <i className="iconfont icon-dayu" />;
            break;
        case '<':
            icon = <i className="iconfont icon-xiaoyu" />;
            break;
        case 'between':
            icon = <i className="iconfont icon-jieyu" />;
            break;
        case 'not between':
            icon = <i className="iconfont icon-buzai" />;
            break;
        case '>=':
            icon = <i className="iconfont icon-dayudengyu" />;
            break;
        case '<=':
            icon = <i className="iconfont icon-xiaoyudengyu" />;
            break;
        case '<>':
            icon = <i className="iconfont icon-budengyu" />;
            break;
        case 'like':
            icon = <i className="iconfont icon-baohan" />;
            break;
        case 'left like':
            icon = <i className="iconfont icon-zuobaohan" />;
            break;
        case 'right like':
            icon = <i className="iconfont icon-youbaohan" />;
            break;
        case 'not like':
            icon = <i className="iconfont icon-bubaohan" />;
            break;
        case 'is null':
            icon = <i className="iconfont icon-weikong" />;
            break;
        case 'is not null':
            icon = <i className="iconfont icon-buweikong" />;
            break;
        default:
            break;
    }
    return icon;
};